/// <reference types="vite/client" />
import * as pdfjsLib from "pdfjs-dist";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

// pdf.js's viewer components read the library off globalThis as their module
// is evaluated, not through an import, so this has to run first. PdfScene
// imports this file ahead of pdf_viewer.mjs for exactly that reason.
(globalThis as any).pdfjsLib = pdfjsLib;

// Parsing runs in a worker so a large drawing set does not freeze the page.
// The worker is bundled and served from our own origin, which the CSP's
// worker-src already allows.
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

// Fonts the PDF names but does not embed, and character maps for CJK text.
// Fetched from unpkg at the library's own version rather than shipping 2.5 MB
// in the build. The CSP lets unpkg in through connect-src and font-src.
export const PDFJS_ASSETS = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}`;

export { pdfjsLib };
